module.exports = __webpack_public_path__ + "static/img/20009 (2).599e8b4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (2).webp
// module id = kp8F
// module chunks = 14